<template>
    <!--BLOCK MERCHANT INFO START-->
    <div class="merchantInfo row">
        <span class="merchantName">{{ merchantInfo.siteName }}</span>
        <div class="merhantLegalInfo">
            <span class="merchantLegalName">{{ merchantInfo.siteLegalPerson }}, </span>
            <span class="merchantIndex">{{ merchantInfo.siteZip }}, </span>
            <span class="merchantCountry">{{ merchantInfo.countryName }}, </span>
            <span class="merchantCity">{{ merchantInfo.siteCity }}, </span>
            <span class="merchantAddress">{{ merchantInfo.siteAddress }} </span>
        </div>
        <div class="merchantContactInfo d-flex flex-wrap">
            <span class="merchantPhone"><a :href="'tel:'+merchantInfo.sitePhone">{{ merchantInfo.sitePhone }}</a></span>
            <span class="merchantEmail"><a :href="'mailto:'+merchantInfo.siteEmail">{{ merchantInfo.siteEmail }}</a></span>
        </div>
    </div>
    <!--BLOCK MERCHANT INFO END-->
</template>

<script>
    export default {
        name: 'MerchantInfo',
        props: [
            'merchantInfo'
        ],

    }
</script>
